
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { Modal } from 'ant-design-vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import { IBuscaAvancada } from '@/core/models/BuscaAvancada/IBuscaAvancada';
import storeSistema from '@/store/storeSistema';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { IFiltroGenerico } from '@/core/models/BuscaAvancada/IFiltroGenerico';
import { ICardKanban, ICardKanbanDetalhe, IColunaKanban } from '@/core/models/IKanban';
import Kanban from '@/core/components/Kanban/Kanban.vue';
import { IOrdenacaoRegistro } from '@/core/models/IOrdenacaoRegistro';
import { IPagination } from '@/core/models/AntDesign/IPagination';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import UtilitarioDispositivo from '@/core/utilitarios/UtilitarioDispositivo';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import BuscaGeral from '@/core/components/BuscaAvancada/BuscaGeral.vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import Card from '@/core/components/Tela/Card.vue';
import { EFiltroPeriodoMovimentoComercial } from '@/models/Enumeradores/Compartilhados/EFiltroPeriodoMovimentoComercial';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import { ETipoEtiqueta } from '@/models/Enumeradores/ETipoEtiqueta';
import ServicoProcessoProducao from '@/servicos/Cadastros/PCP/ServicoProcessoProducao';
import { IDTOOrdemProducao } from '@/models/DTO/PCP/IDTOOrdemProducao';
import { IProcessoProducao, IProcessoProducaoEtapa } from '@/models/Entidades/Cadastros/PCP/IProcessoProducao';
import SelecionarFiltroPeriodoMovimentoComercial from '@/components/Compartilhados/SelecionarFiltroPeriodoMovimentoComercial.vue';
import { IDTOAlteracaoEtapaOp } from '@/models/DTO/PCP/IDTOAlteracaoEtapaOp';
import ServicoOrdemProducao from '@/servicos/PCP/ServicoOrdemProducao';
import OrdemProducaoModal from '@/views/PCP/OrdemProducao/OrdemProducaoModal.vue';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import EtapaProcessoProducaoModal from './EtapaProcessoProducaoModal.vue';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { IParametrosConsulta } from '@/core/models/Consulta/IParametrosConsulta';
import ProcessoProducaoListagem from '@/components/PCP/ProcessoProducao/ProcessoProducaoListagem.vue';
import { IParametrosConsultaOps } from '@/models/ParametrosRequisicao/PCP/IParametrosConsultaOps';
import { ETipoDado } from '@/core/models/Enumeradores/ETipoDado';
import { ECondicao } from '@/core/models/Enumeradores/ECondicao';
import { EOperadorLogico } from '@/core/models/Enumeradores/EOperadorLogico';

export default defineComponent({
  name: 'ProcessoProducaoIndex',
  components: {
    Kanban,
    SelecionarDataInicialFinal,
    SelecionarFiltroPeriodoMovimentoComercial,
    TituloPadrao,
    Card,
    BuscaGeral,
    PreviewPdf,
    OrdemProducaoModal,
    EtapaProcessoProducaoModal,
    ProcessoProducaoListagem,
  },
  setup(props) {
    const servicoProcessoProducao = new ServicoProcessoProducao();
    const servicoOrdemProducao = new ServicoOrdemProducao();
    servicoProcessoProducao.requisicaoSistema();
    servicoOrdemProducao.requisicaoSistema();
    const {
      telaBase, preencherEmpresasDisponiveis, filtrarPermissaoDadosUsuarioMultiEmpresas,
      adicionarAtalho, removerAtalho, apresentarMensagemSucesso, apresentarMensagemAlerta, apresentarMensagemErro,
    } = useTelaBase();

    let debounce = 0;
    const state = reactive({
      identificadorRecurso: 'PROCESSO-PRODUCAO',
      tituloRecurso: '',
      empresaSelecionada: 0,
      operacaoLancamento: {} as ITelaOperacao,
      dataAtual: '',
      filtroPeriodo: 4,
      dataInicialSelecionada: '',
      dataFinalSelecionada: '',
      colunas: [] as IColunaKanban[],
      filtros: [] as IFiltroGenerico[],
      ordenacao: [] as IOrdenacao[],
      selecionados: [] as number[],
      processo: {} as IProcessoProducao,
      buscaRapida: '',
      codigoSelecionada: {} as number,
      OPSelecionada: {} as IDTOOrdemProducao,
      carregandoTela: false,
      paginacao: {} as IPagination,
      cardSelecionado: '',
      ops: [] as IDTOOrdemProducao[],
      codigosSelecionados: [] as number[],
      buscaAvancada: {} as IBuscaAvancada,
      codigoLancamento: 0,
      qtdSelecionados: 0,
      visualizarKanban: true,
      arquivosPdf: [] as IArquivoPdf[],
      codigoItemEstoque: 0,
      alteracaoEtapa: {} as IDTOAlteracaoEtapaOp,
      exibirLancamento: false,
      exibirAlteracaoColuna: false,
      etapaSelecionada: {} as IProcessoProducaoEtapa,
    });

    function atualizarQtdSelecionados() {
      state.qtdSelecionados = 0;
      state.colunas.forEach((c) => {
        if (c.qtdSelecionados !== undefined) {
          state.qtdSelecionados += c.qtdSelecionados;
        }
      });
    }

    function atualizarTodosSelecionados() {
      state.colunas.forEach((c, index) => {
        state.colunas[index].qtdSelecionados = 0;
      });
      state.ops.forEach((o) => {
        const indexColuna = state.colunas.findIndex((c) => c.identificador === String(o.codigoProcessoProducaoEtapa));
        if (indexColuna > -1) {
          const indexCard = state.colunas[indexColuna].cards.findIndex((c) => c.identificador === String(o.codigo));
          const indexSelecionados = state.selecionados.findIndex((s) => s === o.codigo);
          if (indexSelecionados >= 0) {
            state.colunas[indexColuna].qtdSelecionados += 1;
            state.colunas[indexColuna].cards[indexCard].selecionado = true;
          } else {
            state.colunas[indexColuna].cards[indexCard].selecionado = false;
          }
        }
      });
      atualizarQtdSelecionados();
    }

    function atualizarSelecionados(identificador: string) {
      atualizarQtdSelecionados();
      const indexSelecionados = state.selecionados.findIndex((s) => s === Number(identificador));
      if (indexSelecionados < 0) {
        state.selecionados.push(Number(identificador));
      } else {
        state.selecionados.splice(indexSelecionados, 1);
      }
    }

    function preencherCards() {
      state.selecionados = [] as number[];
      state.colunas.forEach((c, index) => {
        state.colunas[index].cards = [] as ICardKanban[];
      });

      state.ops.forEach((o) => {
        const card = {} as ICardKanban;
        const indexSelecionados = state.selecionados.findIndex((s) => s === o.codigo);
        const indexColuna = state.colunas.findIndex((c) => c.identificador === String(o.codigoProcessoProducaoEtapa));
        if (indexColuna > -1) {
          card.identificadorColuna = String(o.codigoProcessoProducaoEtapa);
          card.identificador = String(o.codigo);
          card.titulo = `Nº: ${o.numeroInterno}`;
          card.valor = o.quantidade;
          card.ordem = o.ordem;
          card.selecionado = indexSelecionados >= 0;
          card.detalhes = [] as ICardKanbanDetalhe[];

          const detalhe = {} as ICardKanbanDetalhe;
          detalhe.titulo = o.descricao;
          if (detalhe.titulo.length > 29) {
            detalhe.titulo = detalhe.titulo.substring(0, 29);
          }
          card.detalhes.push(detalhe);

          const detalhe2 = {} as ICardKanbanDetalhe;
          detalhe2.titulo = 'Data de Criação: ';
          detalhe2.detalhe = UtilitarioData.aplicaFormatoDataHoraMinuto(o.dataCriacao);
          card.detalhes.push(detalhe2);

          const detalhe3 = {} as ICardKanbanDetalhe;
          detalhe3.titulo = 'Lote: ';
          detalhe3.detalhe = o.numeroLote;
          card.detalhes.push(detalhe3);

          const detalhe4 = {} as ICardKanbanDetalhe;
          detalhe4.titulo = 'Quantidade: ';
          detalhe4.detalhe = o.qtdFormatada;
          card.detalhes.push(detalhe4);

          state.colunas[indexColuna].cards.push(card);
          if (indexSelecionados >= 0) state.colunas[indexColuna].qtdSelecionados += 1;
        }
      });
      atualizarTodosSelecionados();
    }

    function prencheDatasPeriodo() {
      switch (state.filtroPeriodo) {
        case EFiltroPeriodoMovimentoComercial.Hoje:
          state.dataInicialSelecionada = state.dataAtual;
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ontem:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          state.dataFinalSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          break;

        case EFiltroPeriodoMovimentoComercial.SemanaAtual:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 7);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.MesAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaMes(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaMes(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.AnoAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaAno(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaAno(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos15Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 15);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos30Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 30);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos60Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 60);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos90dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 90);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        default:
      }
    }

    function normalizarIdentificador(identificador: string) {
      return (identificador ?? '').toString().trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    }

    function obterIdentificadorConsulta(identificadorColuna: string) {
      const identificadorNormalizado = normalizarIdentificador(identificadorColuna);
      const propriedadeExata = telaBase.propriedadesConsulta.find((item) => normalizarIdentificador(item.identificador) === identificadorNormalizado);
      if (propriedadeExata !== undefined) {
        return propriedadeExata.identificador;
      }

      const propriedadePorSimilaridade = telaBase.propriedadesConsulta.find((item) => {
        const identificadorPropriedade = normalizarIdentificador(item.identificador);
        return identificadorPropriedade.includes(identificadorNormalizado)
          || identificadorNormalizado.includes(identificadorPropriedade);
      });

      return propriedadePorSimilaridade?.identificador ?? identificadorColuna;
    }

    function obterPropriedadeConsulta(identificadorColuna: string) {
      const identificadorConsulta = obterIdentificadorConsulta(identificadorColuna);
      const identificadorNormalizado = identificadorConsulta.trim().toLowerCase();
      return telaBase.propriedadesConsulta.find((item) => item.identificador.toLowerCase() === identificadorNormalizado);
    }

    function normalizarDataCabecalho(valor: string): string {
      const termo = valor.trim();
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(termo)) {
        const [dia, mes, ano] = termo.split('/');
        return `${ano}-${mes}-${dia}`;
      }

      if (/^\d{4}-\d{2}-\d{2}$/.test(termo)) {
        return termo;
      }

      const dataConvertida = UtilitarioData.converterDataJson(termo);
      return dataConvertida === 'Invalid Date' ? '' : dataConvertida;
    }

    function adicionarFiltrosCabecalhoAplicados(filtrosCabecalho: Record<string, string>) {
      Object.entries(filtrosCabecalho).forEach(([identificadorColuna, valor]) => {
        const termo = (valor ?? '').toString().trim();
        if (!termo) {
          return;
        }

        const identificador = obterIdentificadorConsulta(identificadorColuna);
        const propriedade = obterPropriedadeConsulta(identificadorColuna);
        const tipoDado = propriedade?.tipoDado ?? ETipoDado.Texto;
        const filtroEhData = tipoDado === ETipoDado.Data;
        const filtroEhDataHora = tipoDado === ETipoDado.DataHoraMinuto
          || tipoDado === ETipoDado.DataHoraMinutoSegundo;

        if (filtroEhData || filtroEhDataHora) {
          const dataNormalizada = normalizarDataCabecalho(termo);
          if (!dataNormalizada) {
            return;
          }

          if (filtroEhDataHora) {
            state.filtros.push({
              identificador,
              apresentacao: `${propriedade?.apresentacao ?? identificador}: maior ou igual a ${termo}`,
              condicao: ECondicao.MaiorOuIgual,
              valores: [`${dataNormalizada}T00:00:00`],
              tipoDado,
              operador: EOperadorLogico.E,
            } as IFiltroGenerico);

            state.filtros.push({
              identificador,
              apresentacao: `${propriedade?.apresentacao ?? identificador}: menor ou igual a ${termo}`,
              condicao: ECondicao.MenorOuIgual,
              valores: [`${dataNormalizada}T23:59:59`],
              tipoDado,
              operador: EOperadorLogico.E,
            } as IFiltroGenerico);
            return;
          }

          state.filtros.push({
            identificador,
            apresentacao: `${propriedade?.apresentacao ?? identificador}: igual a ${termo}`,
            condicao: ECondicao.Igual,
            valores: [dataNormalizada],
            tipoDado,
            operador: EOperadorLogico.E,
          } as IFiltroGenerico);
          return;
        }

        const condicao = tipoDado === ETipoDado.Texto ? ECondicao.Contem : ECondicao.Igual;
        state.filtros.push({
          identificador,
          apresentacao: `${propriedade?.apresentacao ?? identificador}: ${condicao === ECondicao.Contem ? 'contém' : 'igual a'} ${termo}`,
          condicao,
          valores: [termo],
          tipoDado,
          operador: EOperadorLogico.E,
        } as IFiltroGenerico);
      });
    }

    async function buscarOps(ordenacao: IOrdenacao[] = [], filtrosCabecalho: Record<string, string> = {}) {
      state.ops = [];
      state.filtros = [] as IFiltroGenerico[];
      if (UtilitarioGeral.validaLista(state.buscaAvancada.filtrosAdicionados)) {
        state.buscaAvancada.filtrosAdicionados.forEach((item) => {
          state.filtros.push(item.filtro);
        });
      }
      adicionarFiltrosCabecalhoAplicados(filtrosCabecalho);

      prencheDatasPeriodo();
      const parametrosConsulta = {} as IParametrosConsultaOps;
      parametrosConsulta.periodo = state.filtroPeriodo;
      parametrosConsulta.dataInicial = state.dataInicialSelecionada;
      parametrosConsulta.dataFinal = state.dataFinalSelecionada;
      parametrosConsulta.valorBuscaRapida = state.buscaRapida;
      parametrosConsulta.empresas = [state.empresaSelecionada];
      parametrosConsulta.ordenacao = Array<string>();

      if (UtilitarioGeral.validaLista(ordenacao) && !state.visualizarKanban) {
        ordenacao.forEach((item) => {
          const identificadorOrdenacao = obterIdentificadorConsulta(item.identificador);
          parametrosConsulta.ordenacao.push(`${identificadorOrdenacao}|${item.ordem}`);
        });
      } else {
        parametrosConsulta.ordenacao.push('Status', 'NumeroInternoOrdemProducao|DESC');
      }

      parametrosConsulta.qtdeRegistrosPagina = 1000;

      telaBase.carregando = true;
      const listaPaginada = await servicoOrdemProducao.buscaAvancada(parametrosConsulta, state.filtros);
      state.ops = listaPaginada.dados;
      telaBase.carregando = false;
      preencherCards();
    }

    async function buscarOpsAposAcoes() {
      clearTimeout(debounce);
      debounce = setTimeout(async () => {
        await buscarOps();
      }, 600);
    }

    async function atualizarOrdemCards(ordenacaoRegistros: IOrdenacaoRegistro[]) {
      await servicoOrdemProducao.atualizarOrdenacao(state.empresaSelecionada, ordenacaoRegistros);
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [] as number[];
      telaBase.empresasSelecionadas.push(state.empresaSelecionada);
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(telaBase.empresasSelecionadas);
      await buscarOps();
    }

    function selecionarCard(selecionado: string) {
      state.cardSelecionado = selecionado;
    }

    function incluirOp() {
      state.operacaoLancamento = {} as ITelaOperacao;
      state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Incluir;
      state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
      state.operacaoLancamento.codigoRegistro = 0;
      state.operacaoLancamento.empresaSelecionada = state.empresaSelecionada;
      state.exibirLancamento = true;
    }

    function editarOp(codigo: number) {
      state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Alterar;
      state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
      state.operacaoLancamento.codigoRegistro = codigo;
      state.operacaoLancamento.empresaSelecionada = state.empresaSelecionada;
      state.exibirLancamento = true;
    }

    function clickEditar() {
      editarOp(Number(state.cardSelecionado));
    }

    async function alterarEtapa(indexOp: number, etapaAnterior: IProcessoProducaoEtapa, etapaNova: IProcessoProducaoEtapa) {
      let index = state.ops.findIndex((o) => o.codigo === state.codigoSelecionada);
      if (index === -1) index = indexOp;
      const op = state.ops[index];
      Modal.confirm({
        title: `Realmente deseja passar a OP da etapa ${etapaAnterior.nome} para a etapa ${etapaNova.nome}?`,
        content: `OP ${op.numeroInterno} criada no dia ${UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(op.dataCriacao)}.`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          const retorno = await servicoOrdemProducao.atualizarEtapa(op.codigo, etapaNova.codigo);
          if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
            state.ops[index].codigoProcessoProducaoEtapa = etapaNova.codigo;
            apresentarMensagemSucesso(`Etapa da OP ${op.numeroInterno} alterada com sucesso!`);
            buscarOpsAposAcoes();
          } else {
            apresentarMensagemErro(retorno.mensagem);
            preencherCards();
          }
        },
        onCancel: () => {
          preencherCards();
        },
      });
    }

    async function moverCard(card: ICardKanban, identificadorNovaColuna: string) {
      state.cardSelecionado = card.identificador;
      const indexOp = state.ops.findIndex((r) => r.codigo === Number(state.cardSelecionado));
      const op = state.ops[indexOp];

      const indexEtapaAnterior = state.processo.etapas.findIndex((e) => e.codigo === op.codigoProcessoProducaoEtapa);
      const indexEtapaNova = state.processo.etapas.findIndex((e) => e.codigo === Number(identificadorNovaColuna));
      const etapaAnterior = state.processo.etapas[indexEtapaAnterior];
      const etapaNova = state.processo.etapas[indexEtapaNova];
      alterarEtapa(indexOp, etapaAnterior, etapaNova);
    }

    function criarColuna(etapa: IProcessoProducaoEtapa) {
      const coluna = {} as IColunaKanban;
      coluna.identificador = String(etapa.codigo);
      coluna.titulo = etapa.nome;
      coluna.cor = etapa.cor;
      coluna.cards = [] as ICardKanban[];
      state.colunas.push(coluna);
    }

    async function imprimir(tipoArquivoRelatorio:ETipoArquivo, codigoRegistro?:number) {
      state.filtros = [];

      const parametrosConsulta = {} as IParametrosConsulta;
      parametrosConsulta.empresas = [state.empresaSelecionada];
      parametrosConsulta.numeroPagina = 1;
      parametrosConsulta.qtdeRegistrosPagina = 0;
      parametrosConsulta.qtdeRegistrosTotal = 0;
      parametrosConsulta.ordenacao = Array<string>();

      state.ordenacao.forEach((item) => {
        parametrosConsulta.ordenacao.push(`${item.identificador}|${item.ordem}`);
      });
      const codigosSelecionados: number[] = [];
      if (codigoRegistro !== undefined && codigoRegistro > 0) {
        codigosSelecionados.push(codigoRegistro);
      }

      telaBase.carregando = true;
      const retornoRelatorio = await servicoOrdemProducao.relatorioPadrao(tipoArquivoRelatorio, parametrosConsulta, state.filtros, codigosSelecionados);
      telaBase.carregando = false;
      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivosPdf = [{ nome: '', link: retornoRelatorio.link } as IArquivoPdf];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Erro) {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    function preencherColunas() {
      state.colunas = [] as IColunaKanban[];
      state.processo.etapas.forEach((e) => {
        criarColuna(e);
      });
      const colunaAdicao = {} as IColunaKanban;
      colunaAdicao.identificador = '';
      colunaAdicao.titulo = '';
      colunaAdicao.cor = '';
      colunaAdicao.cards = [] as ICardKanban[];
      colunaAdicao.colunaAdicao = true;
      state.colunas.push(colunaAdicao);
      preencherCards();
    }

    async function obterProcesso() {
      state.carregandoTela = true;
      state.processo = await servicoProcessoProducao.obterPorEmpresa(state.empresaSelecionada);
      state.tituloRecurso = state.processo.nome;
      preencherColunas();
      await buscarOpsAposAcoes();
      state.carregandoTela = false;
    }

    async function periodoAlterado() {
      if (state.filtroPeriodo !== EFiltroPeriodoMovimentoComercial.Personalizado) {
        await buscarOps();
      }
    }

    function limparCampos() {
      state.processo = {} as IProcessoProducao;
      state.processo.etapas = [] as IProcessoProducaoEtapa[];
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      state.colunas = [] as IColunaKanban[];
      state.filtros = [] as IFiltroGenerico[];
      state.OPSelecionada = {} as IDTOOrdemProducao;
      state.selecionados = [] as number[];
      state.paginacao = {} as IPagination;
      state.cardSelecionado = '';
      state.ops = [] as IDTOOrdemProducao[];
      state.buscaAvancada = {} as IBuscaAvancada;
      state.codigoLancamento = 0;
      state.qtdSelecionados = 0;
      state.visualizarKanban = !UtilitarioDispositivo.larguraTelaMobile();
      state.codigoItemEstoque = 0;
    }

    function clickSubMenu(identificador: string) {
      state.cardSelecionado = identificador;
    }

    function abrirCriacaoEtapa() {
      state.etapaSelecionada = {} as IProcessoProducaoEtapa;
      state.exibirAlteracaoColuna = true;
    }

    function abrirEdicaoEtapa(identificacaoColuna: string) {
      state.etapaSelecionada = state.processo.etapas.find((e) => e.codigo === Number(identificacaoColuna)) as IProcessoProducaoEtapa;
      state.exibirAlteracaoColuna = true;
    }

    function excluirEtapa(identificacaoColuna: string) {
      state.etapaSelecionada = state.processo.etapas.find((e) => e.codigo === Number(identificacaoColuna)) as IProcessoProducaoEtapa;
      Modal.confirm({
        title: `Realmente deseja excluir a etapa ${state.etapaSelecionada.nome}?`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: async () => {
          const retorno = await servicoProcessoProducao.excluirEtapa(state.etapaSelecionada.codigo, state.empresaSelecionada);
          if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
            state.processo.etapas.splice(state.processo.etapas.findIndex((e) => e.codigo === state.etapaSelecionada.codigo), 1);
            preencherColunas();
          } else {
            apresentarMensagemErro(retorno.mensagem);
            preencherCards();
          }
        },
      });
    }

    onBeforeMount(async () => {
      limparCampos();
      await preencherEmpresasDisponiveis();
      obterProcesso();
      telaBase.identificadorRecurso = state.identificadorRecurso;
      telaBase.propriedadesConsulta = await servicoOrdemProducao.obterPropriedadesConsulta();
      state.dataAtual = await new ServicoSistema().obterDataAtual();
      state.buscaAvancada.filtrosAdicionados = [];
      state.buscaAvancada.chaveFiltrosAdicionados = 0;
      if (telaBase.propriedadesConsulta.length > 0) {
        state.buscaAvancada.filtros = telaBase.propriedadesConsulta.filter((item) => item.filtro === true);
        state.buscaAvancada.ordenacao = telaBase.propriedadesConsulta.filter((item) => item.ordenacao === true);
      }
    });

    return {
      state,
      props,
      telaBase,
      storeSistema,
      preencherColunas,
      incluirOp,
      editarOp,
      clickEditar,
      buscarOps,
      imprimir,
      EFiltroPeriodoMovimentoComercial,
      ETipoEtiqueta,
      ETipoArquivo,
      atualizarSelecaoEmpresas,
      adicionarAtalho,
      removerAtalho,
      selecionarCard,
      periodoAlterado,
      moverCard,
      atualizarSelecionados,
      atualizarOrdemCards,
      atualizarTodosSelecionados,
      clickSubMenu,
      obterProcesso,
      preencherCards,
      abrirCriacaoEtapa,
      abrirEdicaoEtapa,
      excluirEtapa,
    };
  },
});
